import { TFunction } from 'hooks/useI18n';
import { SectionHeroDataProps } from '../shared/sectionHero/SectionHero.types';
import {
  LocationOfferedDataProps,
  MostOfferedPerksDataProps,
  MostWantedRolesDataProps,
  SalaryOfferedVsWantedDataProps
} from './Companies.types';

export const HERODATA = (t: TFunction): SectionHeroDataProps[] => [
  {
    value: '34%',
    desc: t('mandecar23.companies.hero.key-point-1')
  },
  {
    value: '32%',
    desc: t('mandecar23.companies.hero.key-point-2')
  },
  {
    value: '85%',
    desc: t('mandecar23.companies.hero.key-point-3')
  },
  {
    value: '13%',
    desc: t('mandecar23.companies.hero.key-point-4')
  }
];

export const SALARYOFFEREDVSWANTED: SalaryOfferedVsWantedDataProps[] = [
  {
    role: 'Backend Developer',
    manfredite: 42.08866770157976,
    offer: 45.27777777777778
  },
  {
    role: 'Data Analysis & BI',
    manfredite: 42.338007380073805,
    offer: 48.6875
  },
  {
    role: 'Data Engineer',
    manfredite: 48.58155487804878,
    offer: 50.94827586206896
  },
  {
    role: 'Data Scientist',
    manfredite: 44.12593144560358,
    offer: 56.666666666666664
  },
  {
    role: 'DevOps & Infra. & SRE',
    manfredite: 52.25455465587044,
    offer: 48.36486486486487
  },
  {
    role: 'Engineering Management',
    manfredite: 66.12371888726207,
    offer: 55.27777777777778
  },
  {
    role: 'Frontend Developer',
    manfredite: 36.71053915589168,
    offer: 41.44017094017094
  },
  {
    role: 'Full-stack Developer',
    manfredite: 39.66630837214858,
    offer: 41.75925925925926
  },
  {
    role: 'Mobile Developer',
    manfredite: 42.381547619047616,
    offer: 45.354838709677416
  },
  {
    role: 'Product Design (UI/UX)',
    manfredite: 35.79018961253092,
    offer: 42.5
  },
  {
    role: 'Product Manager',
    manfredite: 53.84952978056426,
    offer: 51.25
  },
  {
    role: 'Project & Delivery Manager',
    manfredite: 52.51606978879706,
    offer: 45.25
  },
  {
    role: 'QA & Testing Engineer',
    manfredite: 40.28527607361963,
    offer: 37.85
  },
  {
    role: 'Software Architect',
    manfredite: 58.591287458379576,
    offer: 53.57142857142857
  },
  {
    role: 'SysAdmin',
    manfredite: 42.397146254458974,
    offer: 36.5
  },
  {
    role: 'Tech Lead',
    manfredite: 61.892105263157895,
    offer: 52.05
  }
];

export const MOSTWANTEDROLES = (
  locale: string | undefined
): MostWantedRolesDataProps[] => [
  {
    role: 'Backend Developer',
    value: 34.32835820895522,
    fill: '#08306B'
  },
  {
    role: 'Frontend Developer',
    value: 19.402985074626866,
    fill: '#08306B'
  },
  {
    role: 'DevOps & Infra. & SRE',
    value: 6.135986733001658,
    fill: '#08306B'
  },
  {
    role: 'Mobile Developer',
    value: 5.140961857379768,
    fill: '#08519C'
  },
  {
    role: 'QA & Testing Engineer',
    value: 4.975124378109453,
    fill: '#08519C'
  },
  {
    role: 'Data Engineer',
    value: 4.809286898839138,
    fill: '#08519C'
  },
  {
    role: 'Full-stack Developer',
    value: 4.477611940298507,
    fill: '#2171B5'
  },
  {
    role: 'Tech Lead',
    value: 3.316749585406302,
    fill: '#2171B5'
  },
  {
    role: 'Project & Delivery Manager',
    value: 1.658374792703151,
    fill: '#2171B5'
  },
  {
    role: 'SysAdmin',
    value: 1.658374792703151,
    fill: '#4292C6'
  },
  {
    role: 'Engineering Management',
    value: 1.4925373134328357,
    fill: '#4292C6'
  },
  {
    role: 'Data Analysis & BI',
    value: 1.3266998341625207,
    fill: '#4292C6'
  },
  {
    role: 'Software Architect',
    value: 1.1608623548922055,
    fill: '#6BAED6'
  },
  {
    role: 'Product Design (UI/UX)',
    value: 1.1608623548922055,
    fill: '#6BAED6'
  },
  {
    role: 'Product Manager',
    value: 0.6633499170812603,
    fill: '#6BAED6'
  },
  {
    role: 'Data Scientist',
    value: 0.4975124378109453,
    fill: '#6BAED6'
  }
];

export const MOSTOFFEREDPERKS = (
  locale: string | undefined
): MostOfferedPerksDataProps[] => [
  {
    perk: {
      en: 'Dynamics and teambuilding events',
      es: 'Dinámicas y eventos de teambuilding'
    },
    value: 11.917543482928924,
    fill: '#08306B'
  },
  {
    perk: {
      en: 'Budget for training',
      es: 'Presupuesto para formación'
    },
    value: 11.488082456517072,
    fill: '#08306B'
  },
  {
    perk: {
      en: 'Internal training events',
      es: 'Eventos de formación internos'
    },
    value: 9.233412067854841,
    fill: '#08519C'
  },
  {
    perk: {
      en: 'Health insurance',
      es: 'Seguro de salud'
    },
    value: 7.494094910886837,
    fill: '#08519C'
  },
  {
    perk: {
      en: 'Possibility to choose your devices',
      es: 'Posibilidad de elegir equipo'
    },
    value: 6.334550139574834,
    fill: '#2171B5'
  },
  {
    perk: {
      en: 'Language classes',
      es: 'Clases de Idiomas'
    },
    value: 6.248657934292463,
    fill: '#2171B5'
  },
  {
    perk: {
      en: 'Budget for Conferences',
      es: 'Presupuesto para Conferencias'
    },
    value: 6.119819626368907,
    fill: '#4292C6'
  },
  {
    perk: {
      en: 'Extra holidays',
      es: 'Vacaciones Extra'
    },
    value: 5.668885548636461,
    fill: '#4292C6'
  },
  {
    perk: {
      en: 'Coffee, fruit and snacks',
      es: 'Café, fruta y snacks'
    },
    value: 5.260897573545201,
    fill: '#6BAED6'
  },
  {
    perk: {
      en: 'Welcome pack',
      es: 'Pack de bienvenida'
    },
    value: 5.003220957698089,
    fill: '#6BAED6'
  }
];

export const LOCATIONOFFEREDDATA = (
  t: TFunction
): LocationOfferedDataProps[] => [
  {
    type: 'medium',
    value: 13.007159904534607,
    label: t('mandecar23.companies.locations-offered.hybrid')
  },
  {
    type: 'big',
    value: 85.68019093078759,
    label: t('mandecar23.companies.locations-offered.remote')
  },
  {
    type: 'small',
    value: 1.3126491646778042,
    label: t('mandecar23.companies.locations-offered.onsite')
  }
];
